export const ACTION = Object.freeze({
  USER_LOGIN: 'UserLogin',
  USER_LOGOUT: 'UserLogout',
  GET_VARIETIES: 'GetVarieties',
  UPDATE_VARIETIES: 'UpdateVarieties',
  GET_CROPCYCLES: 'GetCropCycles',
  UPDATE_CROPCYCLES: 'UpdateCropcycles',
  GET_LANDINGDATA: 'LandingPage',
})

export const API = Object.freeze({
  VARIETIES: '/varities',
  CROP_CYCLES: '/cycles',
  LANDING_PAGE: '/landing',
})

export const PAGES = Object.freeze({
  // auth
  LOGIN: '/login',
  LOGOUT: '/logout',

  // misc
  NOT_FOUND: '*',

  // app
  DASHBOARD: '/',
  MASTER_DATA: '/master-data',

  ACTUALS: '/actuals',
  DEMAND_UPDATES: '/demand-strategy',
  IMPORT_EXPORT: '/import-export',
  IMPORT_EXPORT_DETAILS: '/import-export/:requestId/details',
  GLOSSARY: '/glossary',
  ALLOCATIONTEST: '/allocation',

  CREATE_CONTRACT: '/actuals/allocation/create-contract',
})

// Dynamic route paths with parameters
export const DYNAMIC_ROUTES = Object.freeze({
  IMPORT_EXPORT_DETAILS: '/import-export/:requestId/details',
})

export const AssociatedGrowersCardTitle = 'Associated growers to supplier'

export const AssociatedGrowersCardMockData = [
  {
    name: 'Tri-County Farms1',
    address: '555 Main Street Prosper, Texas 75078',
    country: 'USA',
  },
  {
    name: 'Tri-County Farms2',
    address: '555 Main Street Prosper, Texas 75078',
    country: 'USA',
  },
  {
    name: 'Tri-County Farms2',
    address: '555 Main Street Prosper, Texas 75078',
    country: 'USA',
  },
]

export const ContactsCardTitle = 'Contacts'

export const ContactsCardMockData = [
  {
    name: 'Maria Alexander 1',
    title: 'Operations Manager',
    email: 'maria.alexander@countryfarmllc.com',
    phone: '+1 555-555-5555',
  },
  {
    name: 'Maria Alexander 2',
    title: 'Operations Manager',
    email: 'maria.alexander@countryfarmllc.com',
    phone: '+1 555-555-5555',
  },
  {
    name: 'Maria Alexander 3',
    title: 'Operations Manager',
    email: 'maria.alexander@countryfarmllc.com',
    phone: '+1 555-555-5555',
  },
]

export const SupplierCardTitle = 'Prosper Potato Farm (PPF)'

export const SupplierCardMockData = [
  { label: 'Address', value: '555 Main Street Prosper, Texas 75078' },
  { label: 'Country', value: 'USA' },
  { label: 'Grower Type', value: 'Content' },
  { label: 'Directly Contracted', value: 'False' },
  { label: 'Seed Classification', value: 'Content' },
]

export const SupplierTableColumns = [
  { id: 'suppliername', label: 'Supplier Name' },
  { id: 'suppliertype', label: 'Supplier Type' },
  { id: 'seedclassificationid', label: 'Seed Classification' },
  { id: 'isgrowercontracted', label: 'Directly contracted with Growers' },
  { id: 'contactAddress', label: 'Contact address' },
  { id: 'primaryContactPhone', label: 'Primary contact phone' },
  { id: 'actions', label: 'Actions' },
]

// 2. Mock "supplier" data
// export const SupplierTableData = [
//   {
//     id: 1,
//     supplierName: 'Content',
//     supplierType: 'Content',
//     seedClassification: 'Content',
//     directlyContractedWithGrowers: 'Content',
//     contactAddress: 'Content',
//     primaryContactPhone: 'Content',
//     isDirectlyContracted: true,
//     website: 'www.countyfarmllc.com',
//     details: {
//       title: 'Johnson Potato Farm (JPF)',
//       information: [
//         { title: 'Address', value: '555 Main Street Prosper, Texas 75078' },
//         { title: 'Country', value: 'United States of America' },
//         { title: 'Website', value: 'www.countyfarmllc.com' },
//         { title: 'Phone', value: '+1 555-555-5555' },
//         { title: 'Supplier Type', value: 'Content' },
//         { title: 'Seed classification', value: 'Content' },
//       ],
//     },
//     contacts: [
//       {
//         name: 'Maria Alexander',
//         title: 'Operations Manager',
//         email: 'maria.alexander@countyfarmllc.com',
//         phone: '+1 555-555-5555',
//       },
//       {
//         name: 'Jacob Brown',
//         title: 'Field Supervisor',
//         email: 'jacob.brown@countyfarmllc.com',
//         phone: '+1 555-555-9999',
//       },
//       {
//         name: 'Maria Alexander',
//         title: 'Operations Manager',
//         email: 'maria.alexander@countyfarmllc.com',
//         phone: '+1 555-555-5555',
//       },
//     ],
//     growers: [
//       {
//         name: 'Tri-County Farms',
//         address: 'Route 12, SomeTown, SomeState',
//         country: 'USA',
//       },
//       {
//         name: 'Farm & Sons',
//         address: '123 Country Lane, Ruralville, USA',
//         country: 'USA',
//       },
//     ],
//   },
//   {
//     id: 2,
//     supplierName: 'Content',
//     supplierType: 'Content',
//     seedClassification: 'Content',
//     directlyContractedWithGrowers: 'Content',
//     contactAddress: 'Content',
//     primaryContactPhone: 'Content',
//     isDirectlyContracted: true,
//     website: 'www.countyfarmllc.com',
//     details: {
//       title: 'Johnson Potato Farm (JPF) 2',
//       information: [
//         { title: 'Address', value: '555 Main Street Prosper, Texas 75078' },
//         { title: 'Country', value: 'United States of America 2' },
//         { title: 'Website', value: 'www.countyfarmllc.com' },
//         { title: 'Phone', value: '+1 555-555-5555' },
//         { title: 'Supplier Type', value: 'Content' },
//         { title: 'Seed classification', value: 'Content' },
//       ],
//     },
//     contacts: [
//       {
//         name: 'Maria Alexander',
//         title: 'Operations Manager',
//         email: 'maria.alexander@countyfarmllc.com',
//         phone: '+1 555-555-5555',
//       },
//       {
//         name: 'Jacob Brown',
//         title: 'Field Supervisor',
//         email: 'jacob.brown@countyfarmllc.com',
//         phone: '+1 555-555-9999',
//       },
//       {
//         name: 'Maria Alexander',
//         title: 'Operations Manager',
//         email: 'maria.alexander@countyfarmllc.com',
//         phone: '+1 555-555-5555',
//       },
//     ],
//     growers: [
//       {
//         name: 'Tri-County Farms',
//         address: 'Route 12, SomeTown, SomeState',
//         country: 'USA',
//       },
//       {
//         name: 'Farm & Sons',
//         address: '123 Country Lane, Ruralville, USA',
//         country: 'USA',
//       },
//     ],
//   },
//   {
//     id: 3,
//     supplierName: 'Content',
//     supplierType: 'Content',
//     seedClassification: 'Content',
//     directlyContractedWithGrowers: 'Content',
//     contactAddress: 'Content',
//     primaryContactPhone: 'Content',
//     isDirectlyContracted: true,
//     website: 'www.countyfarmllc.com',
//     details: {
//       title: 'Johnson Potato Farm (JPF) 3',
//       information: [
//         { title: 'Address', value: '555 Main Street Prosper, Texas 75078' },
//         { title: 'Country', value: 'United States of America 3' },
//         { title: 'Website', value: 'www.countyfarmllc.com' },
//         { title: 'Phone', value: '+1 555-555-5555' },
//         { title: 'Supplier Type', value: 'Content' },
//         { title: 'Seed classification', value: 'Content' },
//       ],
//     },
//     contacts: [
//       {
//         name: 'Maria Alexander',
//         title: 'Operations Manager',
//         email: 'maria.alexander@countyfarmllc.com',
//         phone: '+1 555-555-5555',
//       },
//       {
//         name: 'Maria Alexander',
//         title: 'Operations Manager',
//         email: 'maria.alexander@countyfarmllc.com',
//         phone: '+1 555-555-5555',
//       },
//       {
//         name: 'Jacob Brown',
//         title: 'Field Supervisor',
//         email: 'jacob.brown@countyfarmllc.com',
//         phone: '+1 555-555-9999',
//       },
//     ],
//     growers: [
//       {
//         name: 'Tri-County Farms',
//         address: 'Route 12, SomeTown, SomeState',
//         country: 'USA',
//       },
//       {
//         name: 'Farm & Sons',
//         address: '123 Country Lane, Ruralville, USA',
//         country: 'USA',
//       },
//     ],
//   },
//   // ... you can add more supplier objects
// ]

export const InfoCardTypes = {
  Linear: 'linear',
  List: 'list',
}

export const InfoCardCrudTypes = {
  View: 'view',
  Edit: 'edit',
  Delete: 'delete',
}

export const ExceptionCategories = {
  horizonException: 'Horizon exception',
  sizeSplitException: 'Size split exception',
  seedClassificationException: 'Seed classification exception',
}

export const HorizontalExceptionMockDataColumns = [
  { columnKey: 'planningHorizonVariance', header: 'PLANNING HORIZON VARIANCE (CYCLES)' },
  { columnKey: 'varietyName', header: 'VARIETY' },
  { columnKey: 'supplierName', header: 'SUPPLIER' },
]

export const HorizontalExceptionMockDataTables = [
  {
    id: 1,
    planningHorizonVariance: 'Content',
    varietyName: 'Content',
    supplierName: 'Content',
  },
  {
    id: 2,
    planningHorizonVariance: 'Content',
    varietyName: 'Content',
    supplierName: 'Content',
  },
  {
    id: 3,
    planningHorizonVariance: 'Content',
    varietyName: 'Content',
    supplierName: 'Content',
  },
  {
    id: 4,
    planningHorizonVariance: 'Content',
    varietyid: 'Content',
    supplierName: 'Content',
  },
  {
    id: 5,
    planningHorizonVariance: 'Content',
    varietyName: 'Content',
    supplierName: 'Content',
  },
]

export const SizeSplitExceptionMockDataColumns = [
  { columnKey: 'potatoType', header: 'POTATO TYPE' },
  { columnKey: 'noOfSizeSplits', header: 'NUMBER OF SIZE SPLITS' },
  { columnKey: 'sizeSplitBucket', header: 'SIZE SPLITS BUCKET' },
]

export const SeedClassificationExceptionMockDataColumns = [
  { columnKey: 'seedClassificationName', header: 'SEED CLASS' },
  { columnKey: 'exceptionLocationName', header: 'EXCEPTION LOCATION' },
]

export const SeedClassificationMockDataTables = [
  {
    id: 1,
    seedClassificationName: 'Content',
    exceptionLocationName: 'Content',
  },
  {
    id: 2,
    seedClassificationName: 'Content',
    exceptionLocationName: 'Content',
  },
  {
    id: 3,
    seedClassificationName: 'Content',
    exceptionLocationName: 'Content',
  },
  {
    id: 4,
    seedClassificationName: 'Content',
    exceptionLocationName: 'Content',
  },
  {
    id: 5,
    seedClassificationName: 'Content',
    exceptionLocationName: 'Content',
  },
]

export const SizeSplitExceptionMockDataTables = [
  {
    id: 1,
    potatoType: 'Seed',
    numberOfSizeSplits: '-',
    sizeSplitsBucket: 3,
  },
  {
    id: 2,
    potatoType: 'Minituber',
    numberOfSizeSplits: '3',
    sizeSplitsBucket: '< 12 mm, 12 mm - 15 mm , > 15 mm',
  },
  {
    id: 3,
    potatoType: 'Content',
    numberOfSizeSplits: 'Content',
    sizeSplitsBucket: 'Content',
  },
  {
    id: 4,
    potatoType: 'Content',
    numberOfSizeSplits: 'Content',
    sizeSplitsBucket: 'Content',
  },
  {
    id: 5,
    potatoType: 'Content',
    numberOfSizeSplits: 'Content',
    sizeSplitsBucket: 'Content',
  },
]

export const ExceptionsMockData = {
  HorizontalExceptionMockDataColumns,
  HorizontalExceptionMockDataTables,
  SizeSplitExceptionMockDataColumns,
  SizeSplitExceptionMockDataTables,
  SeedClassificationExceptionMockDataColumns,
  SeedClassificationMockDataTables,
}

export const PagesToHideAddButton = [
  {
    mainPage: 'Crop Cycle Management',
    subPage: [],
  },
  {
    mainPage: 'Program Definition',
    subPage: [0, 1],
  },
]

// Dummy options for each select field \\

export const optionsChipstockDemandPoint = [
  { id: '1', displayText: 'Subunit', isBadge: false },
  { id: '2', displayText: 'BU', isBadge: false },
]

export const optionsExceptions = [
  {
    displayText: 'Horizon exception',
    id: '1',
    isBadge: false,
  },
]

export const optionsPlanningHorizonVariance = [
  {
    displayText: '1',
    id: '1',
    isBadge: false,
  },
  {
    displayText: '2',
    id: '2',
    isBadge: false,
  },
  {
    displayText: '3',
    id: '3',
    isBadge: false,
  },
  {
    displayText: '4',
    id: '4',
    isBadge: false,
  },
  {
    displayText: '5',
    id: '5',
    isBadge: false,
  },
  {
    displayText: '6',
    id: '6',
    isBadge: false,
  },
]

export const cropCyclesOptions = [
  { displayText: '1', id: '1', isBadge: false },
  { displayText: '2', id: '2', isBadge: false },
  { displayText: '3', id: '3', isBadge: false },
  { displayText: '4', id: '4', isBadge: false },
  { displayText: '5', id: '5', isBadge: false },
  { displayText: '6', id: '6', isBadge: false },
  { displayText: '7', id: '7', isBadge: false },
  { displayText: '8', id: '8', isBadge: false },
  { displayText: '9', id: '9', isBadge: false },
  { displayText: '10', id: '10', isBadge: false },
  { displayText: '11', id: '11', isBadge: false },
  { displayText: '12', id: '12', isBadge: false },
]
export const cropCyclesMonthsOptions = [
  { displayText: 'January', id: '1', isBadge: false },
  { displayText: 'February', id: '2', isBadge: false },
  { displayText: 'March', id: '3', isBadge: false },
  { displayText: 'April', id: '4', isBadge: false },
  { displayText: 'May', id: '5', isBadge: false },
  { displayText: 'June', id: '6', isBadge: false },
  { displayText: 'July', id: '7', isBadge: false },
  { displayText: 'August', id: '8', isBadge: false },
  { displayText: 'September', id: '9', isBadge: false },
  { displayText: 'October', id: '10', isBadge: false },
  { displayText: 'November', id: '11', isBadge: false },
  { displayText: 'December', id: '12', isBadge: false },
]
export const tabOptionsDemandStrategy = [
  { label: 'Total Demand', value: 0 },
  { label: 'Variety Strategy', value: 1 },
  { label: 'Variety Sourcing Strategy', value: 2 },
  { label: 'Strategy Summary', value: 3 },
]


export const pastYears = [
  { displayText: '2024', id: '1', isBadge: false },
  { displayText: '2023', id: '2', isBadge: false },
  { displayText: '2021', id: '3', isBadge: false },
]


export const tabOptionsActuals = [
  { label: 'Demand', value: 0 },
  { label: 'Supply', value: 1 },
  { label: 'Allocations Details', value: 2 },
  { label: 'Allocations Summary', value: 3 },
  { label: 'Contracts', value: 4 },
  { label: 'Reports', value: 5 },
]


export const dataActualSummary = [
  {
    tableDetails: {
      columns: [
        {
          id: 'generation',
          label: 'GENERATION',
          type: 'text',
          width: '150px',
        },
        {
          id: 'grower',
          label: 'GROWER',
          type: 'text',
        },
        {
          id: 'lab',
          label: 'LAB',
          type: 'text',
        },
        {
          id: 'totalProduction',
          label: 'TOTAL PRODUCTION',
          type: 'text',
          width: '200px',
        },
      ],
      data: [
        {
          id: 'gen1',
          generation: 'GENERATION',
          grower: 'GROWER',
          lab: 'LAB',
          totalProduction: 'TOTAL PRODUCTION',
          subRows: [
            {
              id: 'gen1-row1',
              generation: 'Gen 1',
              grower: 'Grower 01',
              lab: 'Lab 01',
              totalProduction: '1250',
              type: 'button',
            },
            {
              id: 'gen1-row2',
              generation: 'Gen 1',
              grower: 'Grower 02',
              lab: 'Lab 02',
              totalProduction: '1250',
              type: 'button',
            },
          ],
        },
        {
          id: 'gen2',
          generation: 'GENERATION',
          grower: 'GROWER',
          lab: 'LAB',
          totalProduction: 'TOTAL PRODUCTION',
          subRows: [
            {
              id: 'gen2-row1',
              generation: 'Gen 2',
              grower: 'Grower 01',
              lab: 'Lab 01',
              totalProduction: '1250',
              type: 'button',
            },
            {
              id: 'gen2-row2',
              generation: 'Gen 2',
              grower: 'Grower 02',
              lab: 'Lab 02',
              totalProduction: '1250',
              type: 'button',
            },
          ],
        },
      ],
    },
  },
  {
    tableDetails: {
      columns: [
        {
          id: 'generation',
          label: 'GENERATION',
          width: '150px',
        },
        {
          id: 'grower',
          label: 'GROWER',
        },
        {
          id: 'field',
          label: 'Field',
        },
        {
          id: 'cropClassification',
          label: 'Crop Classification',
          width: '200px',
        },
        {
          id: 'inputSeed',
          label: 'Input Seed',
          width: '200px',
        },
        {
          id: 'inputSeedAllocation',
          label: 'Input seed vs. Allocation',
          type: 'text',
          width: '200px',
        },
        {
          id: 'plantedArea',
          label: 'Planted Area',
          width: '200px',
        },
        {
          id: 'actPlantingRate',
          label: 'Act planting rate',
          width: '200px',
        },
      ],
      data: [
        {
          id: 'gen1',
          generation: 'GENERATION',
          grower: 'GROWER',
          field: 'Field',
          cropClassification: 'Crop Classification',
          inputSeed: 'Input Seed',
          inputSeedAllocation: 'Input seed vs. Allocation',
          plantedArea: 'Planted Area',
          actPlantingRate: 'Act planting rate',
          subRows: [
            {
              id: 'gen1-row1',
              generation: 'Content',
              grower: 'Content',
              field: 'Content',
              cropClassification: 'Content',
              inputSeed: 'Content',
              inputSeedAllocation: 'Content',
              plantedArea: 'Content',
              actPlantingRate: 'Content',
              type: 'input',
            },
            {
              id: 'gen1-row2',
              generation: 'Content',
              grower: 'Content',
              field: 'Content',
              cropClassification: 'Content',
              inputSeed: 'Content',
              inputSeedAllocation: 'Content',
              plantedArea: 'Content',
              actPlantingRate: 'Content',
              type: 'input',
            },
          ],
        },
        {
          id: 'gen2',
          generation: 'GENERATION',
          grower: 'GROWER',
          field: 'Field',
          cropClassification: 'Crop Classification',
          inputSeed: 'Input Seed',
          inputSeedAllocation: 'Input seed vs. Allocation',
          plantedArea: 'Planted Area',
          actPlantingRate: 'Act planting rate',
          subRows: [
            {
              id: 'gen2-row1',
              generation: 'Content',
              grower: 'Content',
              field: 'Content',
              cropClassification: 'Content',
              inputSeed: 'Content',
              inputSeedAllocation: 'Content',
              plantedArea: 'Content',
              actPlantingRate: 'Content',
              type: 'button',
            },
            {
              id: 'gen2-row2',
              generation: 'Content',
              grower: 'Content',
              field: 'Content',
              cropClassification: 'Content',
              inputSeed: 'Content',
              inputSeedAllocation: 'Content',
              plantedArea: 'Content',
              actPlantingRate: 'Content',
              type: 'button',
            },
          ],
        },
      ],
    },
  },
]


export const tabOptionsImportExport = [
  { label: 'Import Export Form', value: 0 },
  { label: 'Request Summary', value: 1 },
]

export const optionsRequestSummary = [
  {
    name: 'Mexico -> PFNA',
    tageDetails: [
      {
        name: 'Import',
        color: 'Auxiliary-600',
      },
      {
        name: 'Approved',
        color: 'Auxiliary-600',
      },
      {
        name: '1867',
        color: 'Auxiliary-600',
      },
      {
        name: 'S4S',
        color: 'Auxiliary-600',
      },
    ],
  },
  {
    name: 'Great Lakes',
    tageDetails: [
      {
        name: 'Domestic',
        color: 'Auxiliary-600',
      },
    ],
  },
  {
    name: 'North East',
    tageDetails: [
      {
        name: 'Domestic',
        color: 'Auxiliary-300',
      },
    ],
  },
  {
    name: 'South East',
    tageDetails: [
      {
        name: 'Domestic',
        color: 'Auxiliary-600',
      },
    ],
  },
]

export const MODAL_TYPE = {
  FLUID: 'fluid',
  LARGE: 'L',
  SMALL: 'S',
  MEDIUM: 'M',
}

export const UploadConstants = {
  Button: 'button',
  DateTime: 'dateTime',
  Date: 'date',
  UploadFile: 'Upload file',
  DragAndDrop: 'Drag and drop your file here',
  OnlyCsv: '(only .csv)',
  DownloadTemplate: 'Download Template',
  UploadTemplate: 'Upload Template',
  UploadProducts: 'Upload Products',
  Edit: 'edit',
  Single: 'single',
  ViewDataTable: 'View Data Table',
  Error: 'error',
  Info: 'info',
  CSV: '.csv',
  Uploading: 'uploading',
  Complete: 'complete',
  CategoryProducts: 'categoryProducts',
  UploadedProducts: 'uploadedProducts',
  UploadStoresFile: 'Upload stores file',
  UploadError: 'Upload Error',
  CorruptedFile: 'Corrupted File',
}

export const NUMBERS = {
  OneThousandTwentyFour: 1024,
  Fifty: 50,
  Hundred: 100,
  Zero: 0,
  one: 1,
}

export const PRICE_TYPE = {
  MONTHLY: 'MONTHLY',
  FLAT_RATE: 'FLAT_RATE',
}
